const errorMessages = {
    "Driving licence number not found": "Driving licence number not found",
    "رقم رخصة القيادة غير متوفر": "Driving licence number not found",
    "license expire": "INVALID-LIC_DATE_EXPIRY",
    "expired license": "INVALID-LIC_DATE_EXPIRY",
    "Active quote exist": (quoteNumber) => `Active quote "${quoteNumber}" exists for the given vehicle chassis number.`,
    "Please try 180 days before the policy expiry Date": (date) => 
        `Please try 180 days before the policy expiry Date: ${date || "Unknown Date"}`, 
    "Policy expired": "Your policy has expired. Please renew.",
    "Invalid policy number": "The policy number provided is invalid. Please check and try again.",
    "Payment failed": "Payment transaction failed. Please retry or contact support."
};

export const getErrorMessage = (errorText) => {
    // Extract the date using regex (format: DD-MMM-YYYY)
    const dateMatch = errorText.match(/\d{2}-[A-Z]{3}-\d{4}/);
    const extractedDate = dateMatch ? dateMatch[0] : null;

    for (let key in errorMessages) {
        if (errorText.includes(key)) {
            return typeof errorMessages[key] === "function" 
                ? errorMessages[key](extractedDate)  
                : errorMessages[key];
        }
    }

    return errorText; // Default: return the original error message
};